import { render } from "./OrderProduct.vue?vue&type=template&id=40bf7a2e&scoped=true"
import script from "./OrderProduct.vue?vue&type=script&lang=js"
export * from "./OrderProduct.vue?vue&type=script&lang=js"

import "./OrderProduct.vue?vue&type=style&index=0&id=40bf7a2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40bf7a2e"]])

export default __exports__